<template>
    <div class="container-fluid">
        <form id="FormPedidos" role="form" method="post" autocomplete="off" onSubmit="return false">
            <CList @FiltrarC="Recuperar" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
                <template slot="Filtros">
                    <div class="col-auto">
                        <label class="col-form-label text-primary">Saldo:</label>
                    </div>
                    <div class="col-auto">
                    <input type="text" class="form-control" readonly :value="$formatNumber(SaldoCliente,'$')">
                    </div>
                </template>

                <template slot="header">
                    <th :class="StyleTh+' text-center'">#</th>
                    <th :class="StyleTh">Folio</th>
                    <th :class="StyleTh">Fecha</th>
                    <th :class="StyleTh">Fecha Vencimiento</th>
                    <th :class="StyleTh">Atraso</th>
                    <th :class="StyleTh">Importe</th>
                    <th :class="StyleTh">Saldo</th>
                </template>
                <template slot="body">
                    <tr v-for="(item,index) in Pagos" :key="index">
                        <td class="text-center"><p :class="StyleTd">{{ index+1 }}</p></td>
                        <td><h6 :class="StylePr">{{ item.Folio }}</h6></td>
                        <td><p :class="StyleTd">{{ $getCleanDate(item.Fecha,false,false) }}</p></td>
                        <td><p :class="StyleTd">{{ $getCleanDate(item.FechaVencimiento,false,false) }}</p></td>
                        <td class="text-end"><h6 :class="StylePr">
                            <template v-if="parseFloat(item.Atraso) > 0">{{ $formatNumber(item.Atraso,'$') }}</template>
                            <template v-else>$0.00</template>
                            
                        </h6></td>
                        <td class="text-end"><h6 :class="StylePr">{{ $formatNumber(item.Importe,'$') }}</h6></td>
                        <td class="text-end"><h6 :class="StylePr">{{ $formatNumber(item.Pendiente,'$') }}</h6></td>
                    </tr>
                    <CSinRegistros :pContIF="Pagos.length" :pColspan="7"></CSinRegistros>
                </template>
            </CList>
        </form>
    </div>
</template>
<script>
import Configs from '@/helpers/VarConfig.js';
export default{
    name:'ListPagos',
    props:['poBtnSave'],
    data(){
        return{
            ConfigModal:{
                ShowLoader:false,
                ClassLoad:false
            },
            Emit:this.poBtnSave.EmitSeccion,
            ConfigList:{
                Title:'',
                BtnNewShow:false,
                ShowTitleFirst:false,
                ShowLoader:false,
                ShowFooter:false
            },
            Filtro:{
                Nombre:'',
                Pagina:1,
                Entrada:25,
                TotalItem:0,
                Placeholder:'Buscar..'
            },
            segurity:{},
            StyleTh:Configs.stylesTable.StyleTh,
            StylePr:Configs.stylesTable.StylePr,
            StyleTd:Configs.stylesTable.StyleTd,
            Pagos:[],
            IdCliente:0,
            SaldoCliente:0
        }
    },
    methods:{
        Recuperar(){
            this.ConfigList.ShowLoader=true,
            this.$http.get('clientepagodetalle',{
                params:{
                    TxtBusqueda:this.Filtro.Nombre,
                    Entrada:this.Filtro.Entrada,
                    Pag:this.Filtro.Pagina,
                    IdCliente:this.IdCliente
                }
            }).then((res)=>{
                this.Pagos=res.data.data.data;
            }).finally(()=>{
                this.ConfigList.ShowLoader=false;
            })
        },
        GetSaldoCliente(){
            this.$http.get('getsaldocliente',{
                params:{
                    IdCliente:this.IdCliente
                }
            }).then((res)=>{
                this.SaldoCliente=res.data.data
            });
        }
    },
    created(){
        this.poBtnSave.Toast=0;
        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>{
            this.IdCliente=Id;
            this.GetSaldoCliente();
            this.poBtnSave.DisableBtn=false;
            this.Recuperar();
        })
    }
}
</script>